var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWct(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.3425 18.359L31.4361 7.41809C29.5487 5.526 26.4656 5.526 24.5854 7.41809L13.6863 18.3373C13.0596 18.9656 13.0596 19.9983 13.6863 20.6266L16.9928 23.9414L19.1899 25.9779C19.8454 26.5846 20.8395 26.5846 21.4951 25.9779L25.8965 21.8977C27.1067 20.7783 28.9653 20.7783 30.1683 21.8977L34.5697 25.9779C35.218 26.5846 36.2193 26.5846 36.8677 25.9779L39.0648 23.9414L42.3425 20.6555C42.9764 20.02 42.9764 18.9945 42.3425 18.359Z",
    fill: "#3DB6D3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.47677 31.4375L24.5783 48.5818C26.4657 50.4739 29.5488 50.4739 31.429 48.5818L48.5305 31.4375C51.4984 28.4622 49.4094 27.5883 47.2339 25.5229L44.5541 22.9737C43.9058 22.3598 42.9044 22.367 42.2489 22.9737L37.8475 27.0539C36.6372 28.1733 34.7787 28.1733 33.5757 27.0539L29.1742 22.9737C28.5259 22.367 27.5246 22.367 26.8763 22.9737L22.4748 27.0539C21.2646 28.1733 19.4061 28.1733 18.203 27.0539L13.8016 22.9737C13.1461 22.367 12.152 22.367 11.4964 22.9737L9.03276 25.2557C6.7708 27.3645 4.37918 28.3322 7.47677 31.4375Z",
    fill: "#E2E1E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWct);
export default __webpack_public_path__ + "static/media/WCT.a365f420585c95124429a580f9431161.svg";
export { ForwardRef as ReactComponent };